var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex items-center"},[_c('input',{staticClass:"cursor-pointer hover:border-gray-500",class:[
			'focus:ring-orange-500 h-5 w-5 text-orange-500',
			_vm.markInputInvalid ? 'border-red-600' : 'border-gray-300',
		],attrs:{"type":"radio","id":_vm.inputId,"name":_vm.name},domProps:{"checked":_vm.isChecked,"value":_vm.radioValue},on:{"change":_vm.onRadioChange}}),_vm._v(" "),_c('label',{class:[
			'flex items-center',
			_vm.isWhite
				? 'pl-3 block text-white-700 cursor-pointer'
				: 'pl-3 block text-gray-700 cursor-pointer',
		],attrs:{"for":_vm.inputId}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.__(_vm.label)))]}),_vm._v(" "),(_vm.tooltipText)?_c('ui-tooltip',{staticClass:"text-green-400 whitespace-normal",attrs:{"icon-stroke-width":2,"icon-class":"ml-1 w-4 h-4","text":_vm.__(_vm.tooltipText)}}):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }